import { UserDto } from "./user.dto";
import { AcceptanceOptionsEnum } from "../../enums";
import { GetStreamUserDto } from "./stream-chat-user.dto";
import { IsArray, IsNotEmpty, IsOptional, IsString, ValidateNested } from "class-validator";
import { Type } from "class-transformer";
import { FileUploadDto } from "./file.dto";
import { Base64AllowedMimeTypes, MaxBase64FileSize } from "../../decorators";
import { ALLOWED_CHANNEL_AVATAR_MIME_TYPES } from "../../constants";
import { EventInstanceDto } from "./event.dto";
import { StreamChatCommunityChannelTypesEnum } from '../../enums';

export interface StreamChatChannelDataDto extends Record<string, unknown> {
	name?: string;
	image?: string;
	type?: string;
	invitationCode?: string;
	isPublicChannel?: boolean;
	joiningByRequest?: boolean;
	membersAutoSyncing?: boolean;
	created_by?: GetStreamUserDto;
}

export interface StreamChatDto {
	cid: string;
	type: string;
	id: string;
	data: StreamChatChannelDataDto & {
		joinedByCurrentUser?: boolean;
		currentUserRequestStatus?: AcceptanceOptionsEnum;
		isRequest?: boolean;
		requestedBy?: string;
		disableImageSyncing?: boolean;
	};
	state: {
		members: Record<string, { user_id: string, user: UserDto }>
	}
}

export class EntityToChatDto {
	groupChat: StreamChatDto;
	user?: UserDto;
	event?: EventInstanceDto;
}

export interface PartialUpdateChatDto {
	set?: Record<string, unknown>;
	unset?: Record<string, unknown>;
}

export class UpdateChatAdminDto {
	@IsOptional()
	@ValidateNested()
	@Type(() => FileUploadDto)
	@MaxBase64FileSize(20)
	@Base64AllowedMimeTypes(ALLOWED_CHANNEL_AVATAR_MIME_TYPES)
	public updatedAvatarImg?: FileUploadDto | null;

	public image?: string | null;

	@IsNotEmpty()
	@IsString()
	public name?: string | null;

	public disableImageSyncing?: boolean | null;

	public joiningByRequest?: boolean | null;

	public membersAutoSyncing?: boolean | null;

	public static fromStreamChat(chat: StreamChatDto): UpdateChatAdminDto {
		const updatedChat = new UpdateChatAdminDto();

		updatedChat.name = chat?.data?.name ?? '';

		return updatedChat;
	}
}

export interface StreamChatSendMessageToUsersResponseDto {
	successfulResults: { targetUserId: string; }[];
	errors: { targetUserId: string; error?: string; }[];
}

export class CreateGroupChannelDto {
	@IsNotEmpty()
	@IsArray()
	@IsString({ each: true })
	public otherMembersIds: string[];

	public name?: string;

	public isPublicChannel?: boolean;

	public joiningByRequest?: boolean;

	public membersAutoSyncing?: boolean;

	public communityId?: string;

	public communityChannelTypeId?: StreamChatCommunityChannelTypesEnum;

	public eventBaseId?: string;
}
